export default __webpack_public_path__ + "static/media/logo.0517a0e1.png";